export const GET_GOOGLE_LOGIN_URL_SELECTOR =
  'login/GET_GOOGLE_LOGIN_URL_SELECTOR';
